/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CountryLanguageRouteRouteImport } from './routes/$country.$language/route'
import { Route as CountryLanguageBryggaRouteImport } from './routes/$country.$language/brygga'
import { Route as CountryLanguageSplatRouteImport } from './routes/$country.$language/$'
import { Route as CountryLanguageModeIndexRouteImport } from './routes/$country.$language/$mode/index'
import { Route as CountryLanguageModeSplatRouteImport } from './routes/$country.$language/$mode/$'
import { Route as CountryLanguageModeDesignCodeRouteImport } from './routes/$country.$language/$mode/design/$code'
import { Route as CountryLanguageModeRangeIdIdRouteImport } from './routes/$country.$language/$mode/$rangeId.$id'

const CountryLanguageRouteRoute = CountryLanguageRouteRouteImport.update({
  id: '/$country/$language',
  path: '/$country/$language',
  getParentRoute: () => rootRouteImport,
} as any)
const CountryLanguageBryggaRoute = CountryLanguageBryggaRouteImport.update({
  id: '/brygga',
  path: '/brygga',
  getParentRoute: () => CountryLanguageRouteRoute,
} as any)
const CountryLanguageSplatRoute = CountryLanguageSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => CountryLanguageRouteRoute,
} as any)
const CountryLanguageModeIndexRoute =
  CountryLanguageModeIndexRouteImport.update({
    id: '/$mode/',
    path: '/$mode/',
    getParentRoute: () => CountryLanguageRouteRoute,
  } as any)
const CountryLanguageModeSplatRoute =
  CountryLanguageModeSplatRouteImport.update({
    id: '/$mode/$',
    path: '/$mode/$',
    getParentRoute: () => CountryLanguageRouteRoute,
  } as any)
const CountryLanguageModeDesignCodeRoute =
  CountryLanguageModeDesignCodeRouteImport.update({
    id: '/$mode/design/$code',
    path: '/$mode/design/$code',
    getParentRoute: () => CountryLanguageRouteRoute,
  } as any)
const CountryLanguageModeRangeIdIdRoute =
  CountryLanguageModeRangeIdIdRouteImport.update({
    id: '/$mode/$rangeId/$id',
    path: '/$mode/$rangeId/$id',
    getParentRoute: () => CountryLanguageRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$country/$language': typeof CountryLanguageRouteRouteWithChildren
  '/$country/$language/$': typeof CountryLanguageSplatRoute
  '/$country/$language/brygga': typeof CountryLanguageBryggaRoute
  '/$country/$language/$mode/$': typeof CountryLanguageModeSplatRoute
  '/$country/$language/$mode/': typeof CountryLanguageModeIndexRoute
  '/$country/$language/$mode/$rangeId/$id': typeof CountryLanguageModeRangeIdIdRoute
  '/$country/$language/$mode/design/$code': typeof CountryLanguageModeDesignCodeRoute
}
export interface FileRoutesByTo {
  '/$country/$language': typeof CountryLanguageRouteRouteWithChildren
  '/$country/$language/$': typeof CountryLanguageSplatRoute
  '/$country/$language/brygga': typeof CountryLanguageBryggaRoute
  '/$country/$language/$mode/$': typeof CountryLanguageModeSplatRoute
  '/$country/$language/$mode': typeof CountryLanguageModeIndexRoute
  '/$country/$language/$mode/$rangeId/$id': typeof CountryLanguageModeRangeIdIdRoute
  '/$country/$language/$mode/design/$code': typeof CountryLanguageModeDesignCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$country/$language': typeof CountryLanguageRouteRouteWithChildren
  '/$country/$language/$': typeof CountryLanguageSplatRoute
  '/$country/$language/brygga': typeof CountryLanguageBryggaRoute
  '/$country/$language/$mode/$': typeof CountryLanguageModeSplatRoute
  '/$country/$language/$mode/': typeof CountryLanguageModeIndexRoute
  '/$country/$language/$mode/$rangeId/$id': typeof CountryLanguageModeRangeIdIdRoute
  '/$country/$language/$mode/design/$code': typeof CountryLanguageModeDesignCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$country/$language'
    | '/$country/$language/$'
    | '/$country/$language/brygga'
    | '/$country/$language/$mode/$'
    | '/$country/$language/$mode/'
    | '/$country/$language/$mode/$rangeId/$id'
    | '/$country/$language/$mode/design/$code'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$country/$language'
    | '/$country/$language/$'
    | '/$country/$language/brygga'
    | '/$country/$language/$mode/$'
    | '/$country/$language/$mode'
    | '/$country/$language/$mode/$rangeId/$id'
    | '/$country/$language/$mode/design/$code'
  id:
    | '__root__'
    | '/$country/$language'
    | '/$country/$language/$'
    | '/$country/$language/brygga'
    | '/$country/$language/$mode/$'
    | '/$country/$language/$mode/'
    | '/$country/$language/$mode/$rangeId/$id'
    | '/$country/$language/$mode/design/$code'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CountryLanguageRouteRoute: typeof CountryLanguageRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$country/$language': {
      id: '/$country/$language'
      path: '/$country/$language'
      fullPath: '/$country/$language'
      preLoaderRoute: typeof CountryLanguageRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$country/$language/brygga': {
      id: '/$country/$language/brygga'
      path: '/brygga'
      fullPath: '/$country/$language/brygga'
      preLoaderRoute: typeof CountryLanguageBryggaRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/$': {
      id: '/$country/$language/$'
      path: '/$'
      fullPath: '/$country/$language/$'
      preLoaderRoute: typeof CountryLanguageSplatRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/$mode/': {
      id: '/$country/$language/$mode/'
      path: '/$mode'
      fullPath: '/$country/$language/$mode/'
      preLoaderRoute: typeof CountryLanguageModeIndexRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/$mode/$': {
      id: '/$country/$language/$mode/$'
      path: '/$mode/$'
      fullPath: '/$country/$language/$mode/$'
      preLoaderRoute: typeof CountryLanguageModeSplatRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/$mode/design/$code': {
      id: '/$country/$language/$mode/design/$code'
      path: '/$mode/design/$code'
      fullPath: '/$country/$language/$mode/design/$code'
      preLoaderRoute: typeof CountryLanguageModeDesignCodeRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/$mode/$rangeId/$id': {
      id: '/$country/$language/$mode/$rangeId/$id'
      path: '/$mode/$rangeId/$id'
      fullPath: '/$country/$language/$mode/$rangeId/$id'
      preLoaderRoute: typeof CountryLanguageModeRangeIdIdRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
  }
}

interface CountryLanguageRouteRouteChildren {
  CountryLanguageSplatRoute: typeof CountryLanguageSplatRoute
  CountryLanguageBryggaRoute: typeof CountryLanguageBryggaRoute
  CountryLanguageModeSplatRoute: typeof CountryLanguageModeSplatRoute
  CountryLanguageModeIndexRoute: typeof CountryLanguageModeIndexRoute
  CountryLanguageModeRangeIdIdRoute: typeof CountryLanguageModeRangeIdIdRoute
  CountryLanguageModeDesignCodeRoute: typeof CountryLanguageModeDesignCodeRoute
}

const CountryLanguageRouteRouteChildren: CountryLanguageRouteRouteChildren = {
  CountryLanguageSplatRoute: CountryLanguageSplatRoute,
  CountryLanguageBryggaRoute: CountryLanguageBryggaRoute,
  CountryLanguageModeSplatRoute: CountryLanguageModeSplatRoute,
  CountryLanguageModeIndexRoute: CountryLanguageModeIndexRoute,
  CountryLanguageModeRangeIdIdRoute: CountryLanguageModeRangeIdIdRoute,
  CountryLanguageModeDesignCodeRoute: CountryLanguageModeDesignCodeRoute,
}

const CountryLanguageRouteRouteWithChildren =
  CountryLanguageRouteRoute._addFileChildren(CountryLanguageRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  CountryLanguageRouteRoute: CountryLanguageRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
